import React, { useState } from 'react';
import { Link } from 'react-scroll';
function FAQHubNavigation({ data }) {
  const [index, setIndex] = useState(0);
  return (
    <>
      <div className="faq_hub_nav">
        <div className="container">
          <ul className="faq_list">
            {data?.map((item, idx) => (
              <FAQHubNavItem
                key={idx}
                text={item.primary.topic_name}
                anchorID={`faqTopic-${idx}`}
                isActive={index === idx}
                offset={-80}
                onClick={() => setIndex(idx)}
              />
            ))}
            <FAQHubNavItem
              text={'Submit a question'}
              anchorID={'submit_question'}
              offset={-116}
              isActive={index === 4}
              onClick={() => setIndex(4)}
            />
          </ul>
        </div>
      </div>
      <style jsx>{`
        .faq_list {
          display: flex;
          align-items: center;
          gap: 40px;
          margin: 0;
          padding: 0;
        }
        .container {
          max-width: 1440px;
          margin: 0 auto;
          padding: 0 48px;
          height: 72px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow: auto;
        }
        .faq_hub_nav {
          width: 100%;
          background: #141414;
        }
      `}</style>
    </>
  );
}

function FAQHubNavItem({ text, isActive, anchorID, offset, onClick }) {
  return (
    <>
      <li>
        <Link
          onClick={onClick}
          to={anchorID}
          spy
          smooth
          duration={1000}
          delay={0}
          offset={offset || 0}
        >
          <button className={`faq_hub_nav_button ${isActive && 'active'}`}>
            {text}
          </button>
        </Link>
      </li>
      <style jsx>{`
        .faq_hub_nav_button {
          background: none;
          border: none;
          user-select: none;
          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          color: #e4e4e4;
          opacity: 0.75;
          text-transform: capitalize;
          white-space: nowrap;
        }
        .active {
          color: #fd0300;
          opacity: 1;
        }
      `}</style>
    </>
  );
}

export default FAQHubNavigation;
